export default __webpack_public_path__ + "file-asset/f25abab3ff440f88edf467be160aaa67-CarsonLogoS.svg";